export interface LoaderProps {
  className?: string;
  label: string;
  size?: 'small' | 'medium' | 'large';
}

export function Loader({ className = '', label, size = 'medium' }: LoaderProps) {
  return (
    <output aria-label={label} className={`ui-loader ui-loader-${size} ${className}`.trim()}>
      <span aria-hidden="true" className="ui-loader-spinner" />
      <span className="visually-hidden">{label}</span>
    </output>
  );
}

export function PageLoader({ label }: { label: string }) {
  return (
    <div className="page-loader">
      <Loader label={label} size="large" />
    </div>
  );
}
